import lp from "./pages/lp";

window.EBAY = {
	...window.EBAY,
	HOMESHOPPING: {
		lp // 홈쇼핑 LP
	}
}

/* 예제: lp에서 아래 태그로 실행
	<script>
		EBAY.HOMESHOPPING.lp(model,view, sellerId);
	</script>
*/


// WEBPACK FOOTER //
// ./src/index.js